// extracted by mini-css-extract-plugin
export var backdropBlur = "_id-0";
export var contentCard = "_id-5";
export var frame = "_id-2";
export var image = "_id-4";
export var imagePane = "_id-3";
export var modal = "_id-1";